__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "op-web-service";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.10.4", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(858)]).then(() => (() => (__webpack_require__(59431))))));
			register("@emotion/styled", "11.10.4", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(858), __webpack_require__.e(602)]).then(() => (() => (__webpack_require__(56272))))));
			register("@grafana/faro-react", "2.0.2", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(858), __webpack_require__.e(978)]).then(() => (() => (__webpack_require__(44599))))));
			register("@grafana/faro-web-sdk", "2.0.2", () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(82404))))));
			register("@grafana/faro-web-tracing", "2.0.2", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(978)]).then(() => (() => (__webpack_require__(4270))))));
			register("@mui/material", "5.14.10", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(858), __webpack_require__.e(102), __webpack_require__.e(136), __webpack_require__.e(602), __webpack_require__.e(970)]).then(() => (() => (__webpack_require__(60714))))));
			register("@mui/styles", "5.14.10", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(858), __webpack_require__.e(136)]).then(() => (() => (__webpack_require__(32977))))));
			register("@toorak/op-eventbus-sdk", "3.1.9", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(867)]).then(() => (() => (__webpack_require__(28724))))));
			register("@toorak/web-support-sdk", "1.6.6", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(858), __webpack_require__.e(102)]).then(() => (() => (__webpack_require__(7188))))));
			register("prop-types", "15.8.1", () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(43979))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(858)]).then(() => (() => (__webpack_require__(8568))))));
			register("react-i18next", "11.18.6", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(858)]).then(() => (() => (__webpack_require__(79865))))));
			register("react-query", "3.39.3", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(858), __webpack_require__.e(102)]).then(() => (() => (__webpack_require__(78041))))));
			register("react-router-dom", "6.30.4", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(858), __webpack_require__.e(102)]).then(() => (() => (__webpack_require__(93805))))));
			register("react", "18.3.1", () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(78281))))));
			register("setimmediate", "1.0.5", () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(57310))))));
			initExternal(75702);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};